<template>
  <ButtonDefinitive class="ps-do-step-2"
    label="Continuar"
    @click="next"
  />
</template>

<script>
import ButtonDefinitive from '@/components/Button/ButtonDefinitive.vue'

export default {
  name: "Step2-Type1-Footer",
  components: { ButtonDefinitive },
  mounted() {
    this.$nextTick(() => {});
  },
  created () {
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)) {
      this.$nextTick(() => {
        const appContainer = document.querySelector('.ps-do-step-2');
        if (appContainer) {
          appContainer.classList.add('ios-safari-btn');
        }
      });
    }
  },
  methods: {
    next() {
      if (this.validateData() === 'Ok') {
        this.$store.dispatch("SCHARFFPOINT_PROGRESS_NAV_STEP", 3);
        this.$store.dispatch("STYLE_MAP_SAIO", true);
        this.$store.dispatch("STYLE_SHOW_PM_QUOTER", false);
        this.$store.dispatch("STYLE_PROGRAMMED_STEP_DIV_THREE_GENERAL");
        
        this.trackEvent('click_puntos_envia_paso_2_continuar', 'dropoff');
      } else {
        this.showError(this.validateData());
      }
    },
    validateData() {
      return this.$store.getters.SCHARFFPOINT_VALIDATE_STEP_2;
    },
  }
};
</script>

<style>
@media screen and (max-device-width: 580px) {
  .ios-safari-btn{
    padding-top:2rem;
  }
}
</style>
